export const MAX_APPLICATION_HOURS_LIMIT = 'MaxApplicationHoursLimit';
